module.exports = __webpack_public_path__ + "static/img/wrjj.0123f7e3.png";